export const MAX_VIBEBEE_POSTERS = 20;
export const VIBEBEE_POSTER_TYPES = new Set(["image/jpeg", "image/png", "image/webp"]);
export const TERMINAL_INTAKE_STATUSES = new Set(["completed", "completed_with_review", "failed"]);

function objectUrlApi(urlApi) {
  if (urlApi) return urlApi;
  return typeof window !== "undefined" ? window.URL : null;
}

export function addPosterFiles(current, incoming, urlApi) {
  const candidates = Array.from(incoming || []);
  const unsupported = candidates.find((file) => !VIBEBEE_POSTER_TYPES.has(file?.type));
  if (unsupported) {
    return { items: current, error: `${unsupported.name || "That file"} is not a supported JPEG, PNG or WebP image.` };
  }
  if (current.length + candidates.length > MAX_VIBEBEE_POSTERS) {
    return { items: current, error: `You can attach up to ${MAX_VIBEBEE_POSTERS} poster images.` };
  }
  const previewApi = objectUrlApi(urlApi);
  if (candidates.length && typeof previewApi?.createObjectURL !== "function") {
    return { items: current, error: "Poster previews are unavailable in this browser." };
  }
  const additions = candidates.map((file, index) => ({
    id: `${Date.now()}-${index}-${file.name || "poster"}`,
    file,
    previewUrl: previewApi.createObjectURL(file),
  }));
  return { items: [...current, ...additions], error: "" };
}

export function revokePosterItems(items, urlApi) {
  const previewApi = objectUrlApi(urlApi);
  if (typeof previewApi?.revokeObjectURL !== "function") return;
  for (const item of items || []) {
    if (item?.previewUrl) previewApi.revokeObjectURL(item.previewUrl);
  }
}

export function clipboardImageFiles(clipboardData) {
  return Array.from(clipboardData?.items || [])
    .filter((item) => item.kind === "file" && VIBEBEE_POSTER_TYPES.has(item.type))
    .map((item) => item.getAsFile())
    .filter(Boolean);
}

export function explicitFacebookSourceUrl(text) {
  const matches = String(text || "").match(/https?:\/\/[^\s]+/gi) || [];
  return matches.find((value) => {
    try {
      const host = new URL(value).hostname.toLowerCase();
      return host === "facebook.com" || host === "www.facebook.com" || host === "m.facebook.com";
    } catch {
      return false;
    }
  }) || "";
}

export async function pollEventIntakeBatch(getBatch, batchId, options = {}) {
  const maxAttempts = options.maxAttempts || 80;
  const intervalMs = options.intervalMs ?? 1500;
  const wait = options.wait || ((delay) => new Promise((resolve) => setTimeout(resolve, delay)));
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const batch = await getBatch(batchId);
    options.onProgress?.(batch);
    if (TERMINAL_INTAKE_STATUSES.has(batch?.status)) return batch;
    await wait(intervalMs);
  }
  throw new Error("Poster processing is taking longer than expected. The batch is still available in Event Sources.");
}
